export const GOODS_RECEIPT = 'GoodsReceipt';
export const GoodsReceiptStatusValues = [
    'draft',
    'posted',
    'cancelled',
];
export const GOODS_RECEIPT_STATUS_LABELS = {
    draft: 'Rascunho',
    posted: 'Efetivado',
    cancelled: 'Cancelado',
};
//# sourceMappingURL=goods-receipt.js.map